import config from '../../config';
import { Indicator } from '../../types/next';

const endpoint = config.apiNextEndpoint;

// Fired after something resolves indicators (e.g. a chat was read), so every useIndicators refreshes now
export const INDICATORS_CHANGED_EVENT = 'indicators:changed';

export const notifyIndicatorsChanged = () => window.dispatchEvent(new Event(INDICATORS_CHANGED_EVENT));

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

export const getIndicatorsByType = async (type: string = 'chat'): Promise<Indicator[]> => {
  const response = await fetch(`${endpoint}/indicators/${type}`, {
    method: 'GET',
    headers: getHeaders(),
  });
  const indicators: Indicator[] = await response.json();
  return indicators || [];
};

export const resolveIndicator = async (id: number): Promise<any> => {
  const response = await fetch(`${endpoint}/indicators/${id}`, {
    method: 'PATCH',
    headers: getHeaders(),
  });
  return await response.json();
};
